import React from 'react';
import Header from '../../../components/layout/headers/Header';
import DynamicNavigation from "../../../components/layout/navigation/DynamicNavigation";
import LoanForm from '../components/loanDetails/LoanForm.jsx';

const Loans = () => {
    
    return (
        <>
            <Header />
            <DynamicNavigation />
            <div className="content-body">
                <div className="container">
                    <div className='row'>
                        <div className="col-lg-24">
                            <LoanForm />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Loans;
